import React from 'react';
import styles from './LandingPage.module.css';

const LandingPage = () => {
  return (
    <div className={styles.body}>
      <div className={styles.container}>
        <h1 className={styles.heading}>
          {/* Get instant alerts for out-of-range positions <span className={styles.highlight}>IL warnings</span> on Telegram. */}
          {/* Get instant alerts and impermanent loss warnings for your Sui LPs. */}

          {/* Get instant alerts and Impermanent loss<span className={styles.highlight}> warnings</span> for Sui LPs. */}
          {/* <span className={styles.highlight}>Get instant alerts and Impermanent loss warnings for Sui LPs.</span> */}
          {/* Earn up to 300% APR from Sui LPing. */}
          {/* The fastest way to LP on Sui. */}
          {/* Replace 10 Sui LP checks a day with . No dashboards. */}
          {/* Stop checking Sui LPs 10x a day. No dashboards. */}
          {/* Turn 10x daily Sui LP checks into auto alerts. No dashboards. */}
          Stop checking LP dashboards 10x a day.

          {/* Get instant alerts and <span className={styles.highlight}>IL warnings</span> for your Sui liquidity positions. */}
        </h1>
        {/* <h1 className={styles.heading}>
          Your LP went out of range <span className={styles.highlight}>6 hours ago.</span> Did you even know?
        </h1> */}
        <p className={styles.description}>
        {/* Track your Sui LPs and send Telegram alerts when positions need a rebalance - so you don't live inside charts. */}
        TsunamiFi watches your Sui LPs and only alerts you when prices move past your liquidity or returns drop.
          {/* Get instant alerts for out-of-range positions, IL warnings, and back-in-range notifications on Telegram */}
          {/* Your LP went out of range 6 hours ago. Did you even know? */}
          {/* Get instant alerts and impermanent loss warnings for your Sui LPs. */}
        </p>
        <a 
          href="https://t.me/+dwn-hiwTjWM2M2Fl" 
          className={styles.ctaButton}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg className={styles.telegramIcon} viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.654-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
          </svg>
          Join Telegram
        </a>
        {/* <div className={styles.suiBadge}>Built for Sui blockchain protocols</div> */}
      </div>
    </div>
  );
};

export default LandingPage;